export type AiCostFilterOptionsFetchedPayload = {
	readonly organizations: readonly { readonly id: number; readonly label: string }[];
	readonly facilities: readonly {
		readonly id: number;
		readonly label: string;
		readonly organization: { readonly id: number };
	}[];
	readonly users: readonly {
		readonly id: number;
		readonly label: string;
		readonly isActive: boolean;
		readonly facilities: readonly { readonly id: number }[];
	}[];
};

export type AiCostFilterOptionsFetchedAction = {
	type: 'AI_COST_FILTER_OPTIONS_FETCHED';
	payload: AiCostFilterOptionsFetchedPayload;
	accountId: number;
};

export default (
	payload: AiCostFilterOptionsFetchedPayload,
	accountId: number,
): AiCostFilterOptionsFetchedAction => ({
	type: 'AI_COST_FILTER_OPTIONS_FETCHED',
	payload,
	accountId,
});
